import React from 'react';
import { Table } from 'react-bootstrap';

const AccountsBoard = () => {
  const accounts = [
    { id: 1, company: 'Sunshine Limited', domain: 'sunshine.prospectpulse.com', revenue: '300L' },
    { id: 2, company: 'ABC Corporation', domain: 'abc.prospectpulse.com', revenue: '4.5Cr' },
    { id: 3, company: 'Aerial Inc.', domain: 'aerial.prospectpulse.com', revenue: '300L' },
  ];

  return (
    <div className="mb-4">
      <h6 className="fw-bold mb-3">Accounts</h6>
      <Table bordered hover responsive>
        <thead>
          <tr>
            <th>S.NO</th>
            <th>Company</th>
            <th>Domain</th>
            <th>Revenue</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map((acc, idx) => (
            <tr key={acc.id}>
              <td>{idx + 1}</td>
              <td>{acc.company}</td>
              <td>{acc.domain}</td>
              <td>{acc.revenue}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AccountsBoard;
